export default __webpack_public_path__ + "static/media/veggie_chicken.40fbc5d8.jpg";